import i18n from "i18next";
import { initReactI18next } from "react-i18next";
//import Backend from 'i18next-http-backend'; //Get .json From Backend
import LanguageDetector from 'i18next-browser-languagedetector';
import * as en from 'src/lang/en.json';
import * as es from 'src/lang/es.json';

i18n
  //.use(Backend) //Get .json From Backend
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      en: {
        translation: en.default
      },
      es: {
        translation: es.default
      }
    }, //Para cargar desde variable
    
    //lng: "es" //Comentado cuando se encarga el detector
    initImmediate: false,
    fallbackLng: "en",
    //keySeparator: false, // we do not use keys in form messages.welcome
    //backend: { loadPath: '/src/lang/en.json' },
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

  //i18n.changeLanguage("es") //Primera ejecución para que tome el LanguageDetector

  export default i18n;